import { type FC } from 'react';

import { useModalViewStore } from '@dcentralexpedientedigital/fe-shared/stores/modal-view-store';
import { ModalPopup } from '@dcentralexpedientedigital/fe-ui/components/modal-popup/modal-popup';
import { useTranslate } from '@dcentralexpedientedigital/fe-ui/hooks/use-translate';

import { useLayout } from '../hooks/use-layout';

import { AuthGuardedBlockRenderer } from './auth-guarded-block-renderer';
import { BlockRenderer } from './block-renderer';

export const ModalRenderer: FC = () => {
    const t = useTranslate();

    const [isOpen, configData, closeModal, openModal] = useModalViewStore((state) => [
        state.isOpen,
        state.configData,
        state.closeModal,
        state.openModal,
    ]);
    const layout = useLayout();
    const modalType = layout.declaration.modal?.type ?? 'popup';

    const blocksWithModalCallbacks = configData.blocks.map((block) => {
        return {
            ...block,
            properties: {
                ...(('properties' in block && block.properties) || {}),
                modalCloseCallback: closeModal,
                modalOpenCallback: openModal,
            },
        };
    });

    const header = configData.header ? t(configData.header) : '';

    return (
        <ModalPopup
            isOpen={isOpen}
            closeModal={closeModal}
            onCloseCallback={configData.onCloseCallback}
            heading={header}
            type={modalType}
            shouldCloseOnEsc={configData.options.shouldCloseOnEsc}
            variant={configData.options.variant}
        >
            {configData.requireAuth ? (
                <AuthGuardedBlockRenderer blocks={blocksWithModalCallbacks} />
            ) : (
                <BlockRenderer blocks={blocksWithModalCallbacks} />
            )}
        </ModalPopup>
    );
};
